import React from 'react';

export default class MenuStart extends React.PureComponent {
  render() {
    return (
        <div>
          {/* babel: no self-registration in the app (members are provisioned); the classic page (?classic=1) keeps it */}
          {/[?&]classic=1/.test(window.location.search) ?
            <a href="#" onClick={(e) => {e.preventDefault(); this.props.onSignUp();}}><i className="material-icons">person_add</i></a> : null}
          &nbsp;
          <a href="#" onClick={(e) => {e.preventDefault(); this.props.onSettings();}}><i className="material-icons">settings</i></a>
        </div>
    );
  }
};
